import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '@/assets/app/css/achievementsDetail.module.css';
import { motion } from 'framer-motion';
import TitleHeader from '../common/TitleHeader';
import { eulReul, vAppAjax } from '@/shared/utils/CommonUtil';
import logger from '@/shared/utils/Logger';

interface Achievement {
  id: string;
  category: string;
  name: string;
  description: string;
  current: number;
  total: number;
  color: string;
  icon: string;
}

const achievements = [
  { era: '삼국', title: '주몽 등장', progress: 0, total: 14, color: 'bg-[#F3981F]' },
  { era: '남북국', title: '대조영 등장', progress: 0, total: 14, color: 'bg-[#FDD34E]' },
  { era: '고려', title: '강감찬 등장', progress: 0, total: 14, color: 'bg-[#96CFAC]' },
  { era: '조선', title: '이순신 등장', progress: 0, total: 14, color: 'bg-[#359E52]' },
  { era: '고조선', title: '단군 등장', progress: 0, total: 14, color: 'bg-[#EB615A]' },
];

const Achievements: React.FC = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<CompletedInfo>();

  const loadData = async () => {
    await vAppAjax(
      'get',
      `my/achievements`,
      {},
      (response: AxiosResponse<CommonResult<CompletedInfo>>) => {
        const resultData = response.data;
        if (resultData.code === 200) {
          setData(response.data.result);
        } else {
          logger.warn(resultData.message);
        }
      },
      (error: any) => {
        logger.error(error);
      },
    );
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <TitleHeader title="나의 업적" onBack={() => navigate(-1)} />

      <main className="p-4 space-y-4">
        {/* 상단 요약 카드 */}

        {data?.personName && (
          <div className="flex items-center justify-center gap-3 mb-2">
            <span className="px-3 py-0.5 border border-cyan-400 text-[#14A1C8] text-xs font-bold rounded-full">
              최근
            </span>
            <span className="text-sm color-[#4B4B4B] font-medium">
              {data.personName} · {data.chapterTitle} · {data.categoryName}
            </span>
          </div>
        )}

        <div className="flex items-center justify-center border border-[#e5e5e5] rounded-[14px] w-100p h-[67px] mt-3 mx-auto">
          <div className="flex-1 text-center">
            <div className="text-[16px] font-extrabold text-[#4b4b4b]">
              {data?.completedPerson || 0}
            </div>
            <div className="text-[11px] text-[#8d8d8d] mt-1">완료한 인물</div>
          </div>

          <div className="w-[0.5px] h-[42px] bg-[#efefef]"></div>

          <div className="flex-1 text-center">
            <div className="text-[16px] font-extrabold text-[#4b4b4b]">
              {data?.completedEra || 0}
            </div>
            <div className="text-[11px] text-[#8d8d8d] mt-1">완료한 시대</div>
          </div>
        </div>

        {/* 리스트 */}
        <div className="space-y-1" style={{ borderBottom: '1px solid #f2f2f2' }}>
          {data?.achievements.map((item, idx) => (
            <div
              key={idx}
              className="bg-white py-4 flex items-center gap-4"
              style={{ borderColor: '#F2F2F2', borderTop: '1px solid #f2f2f2' }}
            >
              <div
                className={`w-20 px-2 py-1 rounded-lg flex items-center justify-center text-white font-bold text-sm shrink-0`}
                style={{ background: `${item.themeColor}`, height: 34 }}
              >
                {item.categoryName.replace('시대', '')}
              </div>
              <div className="flex-1">
                <p className="text-sm font-bold mb-1">
                  {item.isAllCompleted ? '달성완료' : item.personName}
                </p>
                <div className="flex items-center gap-2">
                  <div
                    className="h-[16px] bg-[#DDDDDD] rounded-full  overflow-hidden"
                    style={{ width: 200 }}
                  >
                    <motion.div
                      initial={{ width: 0 }}
                      animate={{ width: `${(item.completedChapters / item.totalChapters) * 100}%` }}
                      className="h-full rounded-lg"
                      style={{ backgroundColor: '#14A1C8' }}
                    />
                  </div>
                  <span className="text-xs font-bold" style={{ color: '#14A1C8' }}>
                    {item.completedChapters}/{item.totalChapters}
                  </span>
                </div>
                {!item.isAllCompleted && (
                  <p className="mt-1 text-[#868686] text-[10px]">
                    {item.completedChapters === 0
                      ? `${eulReul(item.categoryName)} 클리어 하세요.`
                      : `${eulReul(item.chapterTitle)} 완료하세요.`}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Achievements;
